enum NftRole {
  NFT_HOLDER = 'NFT Holder',
  NFT_MASTER = 'NFT Master',
  NFT_ELITE = 'NFT Elite',
  NO_HOLDER = 'No NFT',
}
export const getNftRole = (numberOfNft: number) => {
  if (numberOfNft >= 10) {
    return NftRole.NFT_ELITE
  }

  if (numberOfNft >= 5) {
    return NftRole.NFT_MASTER
  }

  if (numberOfNft >= 1) {
    return NftRole.NFT_HOLDER
  }

  return NftRole.NO_HOLDER
}
